<div class="cb-layout-global-controls" *cbGlobalTemplateDefiner="globalControlsKey">
    <ng-content select="cb-button"></ng-content>
</div>